module.exports = __webpack_public_path__ + "static/media/shell.3cf69cad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/shell.png
// module id = 910
// module chunks = 0